import { Errors, request } from "#/utils/request";

interface IGetVendasPlanosCobranca {
  codigoComissionado: string;
  idSimulacao: number;
  seguro: string;
}

export interface IGetVendasPlanosCobrancaData {
  data: Data[];
  errors: Errors;
}

interface Data {
  numeroParcelaInicial: number;
  numeroParcelaFinal: number;
  percentualFundoComum: number;
  valorFundoComum: number;
  percentualTaxaAdm: number;
  valorTaxaAdm: number;
  percentualTaxaAdmAntecipada: number;
  valorTaxaAdmAntecipada: number;
  percentualTaxaAdmDesconto: number;
  valorTaxaAdmDesconto: number;
  percentualAdesao: number;
  valorAdesao: number;
  percentualFundoReserva: number;
  valorFundoReserva: number;
  percentualSeguro: number;
  valorSeguro: number;
  percentualTotal: number;
  valorTotal: number;
  valorLanceMedio: number;
  dataProximoVencimento: string;
  dataProximaAssembleia: string;
  situacaoGrupo: string;
  percentualFundoReservaAoMes: number;
  percentualTaxaAdminAoMes: number;
}

export const getVendasPlanosCobranca = async ({
  codigoComissionado,
  idSimulacao,
  seguro,
}: IGetVendasPlanosCobranca) => {
  return (
    await request.get<IGetVendasPlanosCobrancaData>(
      `/vendas/planos-cobranca?codigoComissionado=${codigoComissionado}&idSimulacao=${idSimulacao}&seguro=${seguro}`
    )
  ).data;
};
